import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarMarine2 extends Component {
  state = {
    registered: {},
  };

  seminar = "marine"; // ✅ unique seminar name for backend

  componentDidMount() {
    this.fetchRegistered();
    // Optional: auto-sync every 10 seconds for real-time updates
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Get the current registration data
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Error fetching Marine registrations:", err);
    }
  };

  // ✅ Handle register/unregister
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // 🔐 Admin PIN for unregister
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });

      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // ✅ Register participant
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  // ✅ Render participant with color logic
  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔵 default / 🔴 registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Marine Martial Arts Dojo Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "CAPT.Teerayut Pakdeepak")}
        <br />
        {this.renderParticipant(2, "นางสาวเมธาพร ฉิมอิ่ม")}
        <br />
        {this.renderParticipant(3, "Mr.Worapot Benjanary")}
        <br />
        {this.renderParticipant(4, "นายอมรพล ทีปะนาถ")}
        <br />
        {this.renderParticipant(5, "Mr.Winyou Chaiyawan")}
        <br />
        {this.renderParticipant(6, "Mr.Thanin Srisethi")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarMarine2;
